export default __webpack_public_path__ + "static/media/mp4.1d16490b.svg";